import script from "./NewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NewPage.vue?vue&type=script&setup=true&lang=js"

import "./NewPage.vue?vue&type=style&index=0&id=272cc598&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-272cc598"]])

export default __exports__